import { useEffect, useState } from "react"

import { useLazyGetOrderStatusWidgetNewQuery } from "store/api/vendorApi"

import { WidgetVendorOrderStatusContent } from "./WidgetVendorOrderStatusContent"

const initialState = {
  new: 0,
  confirmed: 0,
  packed: 0,
  shipping: 0,
  fulfilled: 0,
  denied: 0,
}

interface Props {
  updateIndex?: number
}

export const WidgetVendorOrderStatus = ({ updateIndex }: Props) => {
  const [triggerGetStatus, { isFetching, data }] = useLazyGetOrderStatusWidgetNewQuery()
  const [widgetData, setWidgetData] = useState(initialState)

  useEffect(() => {
    const fetchData = async () => {
      try {
        await triggerGetStatus()
      } catch (error) {
        console.error(error)
      }
    }

    fetchData()
  }, [updateIndex])

  useEffect(() => {
    if (!data) return
    setWidgetData({
      new: data.new,
      confirmed: data.confirmed,
      packed: data.packed,
      shipping: data.shipping,
      fulfilled: data.fulfilled ?? 0,
      denied: data.denied,
    })
  }, [data])

  return <WidgetVendorOrderStatusContent data={widgetData} total={data?.total ?? 0} isLoading={isFetching} />
}
